import axios from "../../fetch-api/fetch-api";
import { IVehicle } from "../../interfaces/session/IVehicle";
import { ICategory, IDynamicUrlDetailsResponse2 } from "../interfaces/category-api.type";
import { computeAndGetParams } from "./computeAndGetParams";

export function getCategoryCanonicalUrlV2(category: ICategory, vehicle: IVehicle, url: string, headers = {}): Promise<string> | Promise<{ data: IDynamicUrlDetailsResponse2 }> {
  return axios.get<IDynamicUrlDetailsResponse2>("s/get-dynamic-url-details-v3", {
    params: computeAndGetParams(category, vehicle, url),
    headers,
  });
}
